/**
 * Component to show Video Section.
 * Its elements are a carousel, a modal which shows video opened, and a modal which has gallery view for videos.
 * Height is being passed to the two modals , in order to have dynamic height for better responsiveness.
 * From the youtube videos' links received from client, we are using id to egenrate thumbnail and src link.
 */
 import React, { useState, useEffect } from 'react';
 import { Image } from "react-bootstrap";
 import "../css/gallerysection.css";
 import "../css/allvideosmodal.css";
 import Carousel from "react-multi-carousel";
 import "react-multi-carousel/lib/styles.css";
 import { generateYtThumbnail, imagePath, videoIdArray, generateYtVideoLink } from '../Utils/index';
 import ReactPlayerWrapper from './ReactPlayerWrapper';
 import Play_Button from "../images/Play_Button.svg"
 
 const responsive = {
     desktop: {
         breakpoint: { max: 3000, min: 1024 },
         items: 1,
         slidesToSlide: 1, // optional, default to 1.
     },
     tablet: {
         breakpoint: { max: 1024, min: 464 },
         items: 1,
         slidesToSlide: 1 // optional, default to 1.
     },
     mobile: {
         breakpoint: { max: 464, min: 0 },
         items: 1,
         slidesToSlide: 1 // optional, default to 1.
     }
 };
 
 const deviceType = window.innerWidth > 575 ? 'desktop' : 'mobile';
 const screenWidthXHeight =[window.innerWidth, window.innerHeight];
 const GallerySection = () => {
     const [isOpenSingleVideo, setIsOpenSingleVideo] = useState(false)
     const [currentVideoId, setCurrentVideoId] = useState('');
     const [mouseActivity, setMouseActivity] = useState(['', '', '']);
     const [isLoading, setisLoading] = useState(['', '', '']);
     const [modalContentHeight, setModalContentHeight] = useState(Math.round(0.7 * screenWidthXHeight[1]))
     const [videoItemsLength, setVideoItemsLength] = useState();
     const handleThumbnailClick = (e, id) => {
         e.preventDefault()
         setIsOpenSingleVideo(true)
         setCurrentVideoId(id)
     }
 
     const latestLoadingUpdate = (currentState) => {
         setisLoading(currentState)
     }
 
     useEffect(() => {
         // for shadow effect in list
         if (screenWidthXHeight[0] < 575) {
             setModalContentHeight(Math.round(0.3 * screenWidthXHeight[1]))
             return
         }
         if (screenWidthXHeight[0] < 765) {
             setModalContentHeight(Math.round(0.3 * screenWidthXHeight[1]))
             return
         }
         if (screenWidthXHeight[0] > 765 && screenWidthXHeight[0] < 1025) {
             setModalContentHeight(Math.round(0.45 * screenWidthXHeight[1]))
             return
         }
         setModalContentHeight(400)
     }, [screenWidthXHeight])
 
     const handleCustomArrowClick = (e, arrowType) => {
         e.preventDefault()
         const domInbuiltArrowName = arrowType === 'Next' ? 'right' : 'left'
         const inbuiltArrow = document.querySelectorAll('.react-multiple-carousel__arrow.react-multiple-carousel__arrow--' + domInbuiltArrowName)
         console.log('CUstom: ', inbuiltArrow)
 
         if (inbuiltArrow && inbuiltArrow.length === 1) {
             inbuiltArrow[0].click()
         }
     }
     const handleOverlayCloseClick = (e) => {
         setIsOpenSingleVideo(false)
         setCurrentVideoId('')
     }
     return (
         <div className="gallery-section-container pt-1">
             {/* <div className=" broker-videos-title" style={{textAlign : "center"}}>
                 {/* LOAN OFFICER  TESTIMONIAL VIDEOS 
         <div className={styles.div}>
         <div className={styles.raise}>
           <span className={styles.itsTimeText}>
           Loan Officer Testimonial
           </span>
           <span> Videos</span>
         </div>
       </div>
             </div> */}
             {isOpenSingleVideo &&
                 <div
                     className={`react-video-overlay ${isLoading ? 'loader-present' : ''}`}
                     id="draggable" >
                     <div id="draggableHeader" title="Hold and drag to move this window">
                         <button title="Close" className="react-video-overlay--close-btn"
                             onClick={(e) => handleOverlayCloseClick(e)}
                         >X</button>
                     </div>
                     <ReactPlayerWrapper
                         width="auto"
                         height={screenWidthXHeight[0] < 575 ? Math.round(modalContentHeight * 1.6) : modalContentHeight}
                         url={generateYtVideoLink(currentVideoId)}
                         latestLoadingUpdate={latestLoadingUpdate}
                         deviceType={deviceType}
                     />
                 </div>
             }
             <div className="video-grid">
                 <div className="slider-custom-arrows video-grid-item arrow-left"
                     style={{
                         backgroundImage: `url(${imagePath}/video/arrow_left.svg)`
                     }}
                     onClick={(e) => handleCustomArrowClick(e, 'Previous')}
                 >
                 </div>
                 <div className="slider-custom-arrows video-grid-item arrow-right"
                     style={{
                         backgroundImage: `url(${imagePath}/video/arrow_right.svg)`
                     }}
                     onClick={(e) => handleCustomArrowClick(e, 'Next')}
                 >
                 </div>
                 <div className="middle-section video-grid-item">
 
                     <Carousel
                         swipeable={true}
                         draggable={true}
                         showDots={false}
                         responsive={responsive}
                         ssr={true} // means to render carousel on server-side.
                         // infinite={videoItemsLength !== videoIdArray.length ? false : true}
                         infinite={false}
                         centerMode={false}//it is false to show single video if you need multiple vidoe make it as true if needded
                         autoPlaySpeed={4000}
                         keyBoardControl={true}
                         containerClass="carousel-container"
                         dotListClass="custom-dot-list-style"
                         itemClass="carousel-item-padding-40-px"
                         customTransition={'transform 200ms linear'}
                     >
                         {
                             videoIdArray.slice(0, videoItemsLength).map((item, index) => (
                                 <>
                                     <div
                                         className="thumbnail-container"
                                     >
                                         {/* please enable this section if view more card is needed for scrolling the videos */}
                                         {/* {index === videoItemsLength -1 && videoItemsLength !== videoIdArray.length ?
                                             <div className="view-more-card thumbnail-image"
                                                 onClick={e => setVideoItemsLength(videoIdArray.length)}
                                             >
                                             </div> : */}
                                             
                                             
                                             <div className={
                                                 `image-wrapper ${item.id === currentVideoId ? 'now-playing' : ''
                                                 }`
                                             }>
                                                 <Image
                                                     className="thumbnail-image"
                                                     src={generateYtThumbnail(item.id)}
                                                     onClick={(e) => {
                                                         handleThumbnailClick(e, item.id)
                                                     }}
                                                     
                                                     draggable="false"
 
                                                     // These three are just to override default onClick
                                                     onDragStart={() => setMouseActivity(state => [true, state[1], state[2]])}
                                                     onMouseMove={() => setMouseActivity(state => [state[0], true, state[2]])}
                                                     onDragEnd={() => setMouseActivity(state => [state[0], state[2], true])}
                                                 ></Image>
                                                 
                                             </div>
                                             
                                         {/* } */}
                                     </div>
                                     <div >
                                     <img src={Play_Button} alt="playbutton" className="Play_Button" 
                                 
                                     onClick={(e) => {
                                         handleThumbnailClick(e, item.id) }}
                                        
                                         />
                                     </div>
                                 </>
                             ))
                         }
                     </Carousel>
                 </div>
             </div>
         </div>
     );
 }
 
 export default GallerySection;